"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../../createStyles"));

var _utils = require("../../utils");

var _styles = _interopRequireWildcard(require("../styles"));

var _excluded = ["className", "spacing", "style", "children", "justify", "align", "reverse", "wrap", "fullWidth", "span", "breakpoints", "jss"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _createStyles["default"])(function (theme) {
  var breakpoints = (0, _styles.generateMediaSupport)(theme.breakpoints);
  var spacing = (0, _styles.generateSpacing)(theme.spacer, _styles.spacing);
  return (0, _extends2["default"])({
    root: {
      display: 'flex'
    },
    flexDirectionColumn: {
      flexDirection: 'column'
    },
    flexDirectionColumnReverse: {
      flexDirection: 'column-reverse'
    }
  }, _styles["default"], breakpoints, spacing);
}, {
  name: 'Col'
});
exports.useStyles = useStyles;

var Col = /*#__PURE__*/_react["default"].forwardRef(function Col(_ref, ref) {
  var _cn;

  var className = _ref.className,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 0 : _ref$spacing,
      style = _ref.style,
      children = _ref.children,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'start' : _ref$justify,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'stretch' : _ref$align,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$span = _ref.span,
      span = _ref$span === void 0 ? 0 : _ref$span,
      breakpoints = _ref.breakpoints,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });

  var _ref2 = breakpoints || {},
      xs = _ref2.xs,
      sm = _ref2.sm,
      md = _ref2.md,
      lg = _ref2.lg,
      xl = _ref2.xl,
      xlg = _ref2.xlg;

  var xsSize = span || xs;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    ref: ref,
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.flexWrap, wrap), (0, _defineProperty2["default"])(_cn, classes["spacing".concat(spacing)], spacing), (0, _defineProperty2["default"])(_cn, classes.fullWidth, fullWidth), (0, _defineProperty2["default"])(_cn, classes.flexDirectionColumn, !reverse), (0, _defineProperty2["default"])(_cn, classes.flexDirectionColumnReverse, reverse), (0, _defineProperty2["default"])(_cn, classes["justify".concat((0, _utils.firstLetterUppercase)(justify))], justify !== 'start'), (0, _defineProperty2["default"])(_cn, classes["alignItems".concat((0, _utils.firstLetterUppercase)(align))], align !== 'stretch'), (0, _defineProperty2["default"])(_cn, classes["col-xs-".concat(xsSize)], xsSize), (0, _defineProperty2["default"])(_cn, classes["col-sm-".concat(sm)], sm), (0, _defineProperty2["default"])(_cn, classes["col-md-".concat(md)], md), (0, _defineProperty2["default"])(_cn, classes["col-lg-".concat(lg)], lg), (0, _defineProperty2["default"])(_cn, classes["col-xl-".concat(xl)], xl), (0, _defineProperty2["default"])(_cn, classes["col-xlg-".concat(xlg)], xlg), _cn), 'col-wrapper', className),
    style: style
  }), children);
}); // Hack for withInfo plugin


Col.displayName = 'Col';
var _default = Col;
exports["default"] = _default;